import { createFeatureSelector, createSelector } from '@ngrx/store';
import { featureKey, State } from './datalists.reducer';

export const getState = createFeatureSelector<State>(featureKey);

export const getDatalistState = createSelector(
    getState,
    (state: State) => state
);

export const getDatalistCountries = createSelector(
    getState,
    (state: State) => state.countries
);

export const getDatalistConsents = createSelector(
    getState,
    (state: State) => state.consents
);
